import * as service from './service'
export default {
  namespace: 'recommendMessengerRecommendRegister',
  state: {
    demoData: {}
  },
  effects: {
    // * demo ({ payload }, { call, put }) {
    //   const res = yield call(service.demo, payload)
    //   yield put({
    //     type: 'save',
    //     payload: {
    //       demoData: res.data
    //     }
    //   })
    // },
    * check ({ payload }, { call, put }) {
      try {
        const res = yield call(service.check, payload)
        const { data, status } = res.data
        if (status === 200) {
          return data
        } else {
          return Promise.reject()
        }
      } catch (error) {
        return Promise.reject()
      }
    },

    * registerBind ({ payload }, { call, put }) {
      try {
        const res = yield call(service.registerBind, payload)
        const { data, status } = res.data
        if (status === 200) {
          return data
        } else {
          return Promise.reject()
        }
      } catch (error) {
        return Promise.reject()
      }
    },

    * sendSmsCode ({ payload }, { call, put }) {
      try {
        const res = yield call(service.sendSmsCode, payload)
        const { data, status } = res.data
        if (status === 200) {
          return data
        } else {
          return Promise.reject()
        }
      } catch (error) {
        return Promise.reject()
      }
    },

    * getCodeBySms ({ payload }, { call, put }) {
      try {
        const res = yield call(service.getCodeBySms, payload)
        const { data, status } = res.data
        if (status === 200) {
          return data
        } else {
          return Promise.reject()
        }
      } catch (error) {
        return Promise.reject()
      }
    },
    * getBanner ({ payload }, { call, put }) {
      try {
        const res = yield call(service.getBanner, payload)
        const { data, status } = res.data
        if (status === 200) {
          return data
        } else {
          return Promise.reject()
        }
      } catch (error) {
        return Promise.reject()
      }
    },
    * courierAge ({ payload }, { call, put }) {
      try {
        const res = yield call(service.courierAge, payload)
        const { data, status } = res.data
        if (status === 200) {
          return data
        } else {
          return Promise.reject()
        }
      } catch (error) {
        return Promise.reject()
      }
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
